<script>
    import { briefForItem } from "../../scripts/wpn2Model";
    
    export let item;
    let itemInfo;

    $: itemInfo = briefForItem(item);
</script>

<div id="brief-col">{itemInfo} </div>

<style>
    #brief-col {
        text-align: left;
    }
</style>
